var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveRedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.70996C7 4.70996 2.73 7.9651 1 12.56C2.73 17.1548 7 20.41 12 20.41C17 20.41 21.27 17.1548 23 12.56C21.27 7.9651 17 4.70996 12 4.70996ZM12 17.7933C9.24 17.7933 7 15.4488 7 12.56C7 9.67117 9.24 7.32663 12 7.32663C14.76 7.32663 17 9.67117 17 12.56C17 15.4488 14.76 17.7933 12 17.7933ZM12 9.41997C10.34 9.41997 9 10.8225 9 12.56C9 14.2974 10.34 15.7 12 15.7C13.66 15.7 15 14.2974 15 12.56C15 10.8225 13.66 9.41997 12 9.41997Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveRedEye);
export default __webpack_public_path__ + "static/media/remove-red-eye.c612805c9bcfa86f6e9532aa09b4e7ba.svg";
export { ForwardRef as ReactComponent };